export const LIGHT_THEME_COLOR = '#F7F6F2';

export const DARK_THEME_COLOR = '#111111';
